<template>
    <div
        v-if="!!items.length"
        :class="{
            'select': true,
            'select--disabled': disabled,
            'select--active': dropdownOpen
        }"
        v-click-away="closeDropdown"
    >
        <div class="select__selected-item" @click="toggleDropdown">
            <span v-if="placeholder" class="select__selected-item-placeholder">{{ placeholder }}</span>
            <span class="select__selected-item-label">
                <span class="select__selected-item-text">{{ selectedItem.title}}</span>
                <svgicon name="arrow-down" />
            </span>
        </div>
        <transition-expand>
            <ul class="select__items" v-if="dropdownOpen">
                <li
                    :class="{
                        'select__item-label': true,
                        'select__item-label--unselectable': item.hasOwnProperty('selectable') && item.selectable === false
                    }"
                    v-show="index != selectedIndex"
                    v-for="(item, index) in items"
                    :key="`select-item-${index}`"
                    @click="() => selectIndex(index)">{{ item.title }}</li>
            </ul>
        </transition-expand>
    </div>
</template>

<script>

import TransitionExpand from '@/components/transitions/TransitionExpand.vue';

export default {
    name: 'SelectElement',
    components: {
        TransitionExpand,
    },
    props: {
        items: {
            type: Array
        },
        placeholder: String,
        selectedValue: String,
        disabled: {
            type: Boolean,
            default: false
        },
    },
    computed: {

        selectedItem() {
            return this.items[this.selectedIndex];
        }
    },
    watch: {
        selectedValue(newValue, oldValue) {
            this.items.forEach((item, index) => {
                if (item.id == this.selectedValue) {
                    this.selectedIndex = index;
                }
            });
        }
    },
    data: () => {
        return {
            selectedIndex: 0,
            dropdownOpen: false,
        }
    },
    created() {
        if (this.selectedValue) {
            this.items.forEach((item, index) => {
                if (item.id == this.selectedValue) {
                    this.selectedIndex = index;
                }
            });
        }

        this.$emit('change', this.items[this.selectedIndex]);
    },
    mounted() {
        document.addEventListener('keydown', this.handleKeyDown);
    },
    methods: {

        selectIndex(index) {

            if (this.disabled) { return }

            if (this.items[index].hasOwnProperty('selectable') && this.items[index].selectable === false) { return }

            if (this.selectedIndex != index) {
                this.selectedIndex = index;
                this.$emit('change', this.items[index]);
            }

            this.dropdownOpen = false;
        },

        toggleDropdown() {
            if (this.disabled) { return }

            this.dropdownOpen = !this.dropdownOpen;
        },

        closeDropdown() {
            this.dropdownOpen = false;
        },

        handleKeyDown(event) {

            if (this.dropdownOpen && event.keyCode == 27) {
                this.closeDropdown();
            }
        },

        getSelectedId() {
            return this.items[this.selectedIndex].id;
        },
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleKeyDown);
    }
}
</script>
